import { AnalyticsStore } from 'bernie-plugin-mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ShortlistToggle } from '@shared-ui/trip-planning-travelpulse';

import { ShortlistModel } from 'models';

import { ProductType } from '__generated__/api';

export interface FavoriteButtonProps {
  analytics?: AnalyticsStore;
  shortlistModel?: ShortlistModel;
  label?: string;
  onSaveMessage?: string;
  rfrrPrefix?: string;
}

@inject('analytics')
@observer
export class FavoriteButton extends React.Component<FavoriteButtonProps> {
  private handleOnChange = (checked: boolean, prevChecked: boolean, dispatch: ({ message: string }) => void) => {
    const { analytics, onSaveMessage, rfrrPrefix } = this.props;

    if (!checked && prevChecked) {
      dispatch({ message: onSaveMessage });
    }

    const referrerId = rfrrPrefix ? rfrrPrefix : 'Shortlist-Toggle';

    const rfrr = checked ? `${referrerId}.RemoveFavorite` : `${referrerId}.SaveFavorite`;
    const linkName = checked ? 'Shortlist-Toggle.Remove from favorite lists' : 'Shortlist-Toggle.Add to favorite lists';

    analytics?.trackEvent(rfrr, linkName, null, null, true);
  };

  public render() {
    const { shortlistModel } = this.props;

    const meta = shortlistModel && shortlistModel.meta;
    const metadata = Object.entries(meta).map(kv => ({
      key: kv[0],
      value: kv[1],
    }));
    const inputs = {
      metadata,
      productId: meta && meta.hotelId,
      productType: ProductType.PROPERTY_DETAILS,
    };

    return (
      <ShortlistToggle
        inputs={inputs}
        initialChecked={shortlistModel && shortlistModel.favorited}
        onChange={this.handleOnChange}
        label={this.props.label}
      />
    );
  }
}
